import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t-4 border-black bg-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 items-start">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start col-span-1 md:col-span-2">
            <Link to="/" className="font-black text-3xl tracking-tighter uppercase mb-4 hover:text-blue-600 transition-colors">
              ETERA
            </Link>
            <p className="font-bold text-sm text-gray-600 italic max-w-xs text-center md:text-left">
              The dynamic QR store for links that last a lifetime. Buy once, update forever.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <h3 className="text-xs font-black uppercase tracking-[0.2em] text-gray-400 mb-2 text-center md:text-left w-full">Resources</h3>
            <Link to="/blog" className="font-black uppercase text-sm hover:underline underline-offset-4 decoration-2">Blog</Link>
            <Link to="/imprint" className="font-black uppercase text-sm hover:underline underline-offset-4 decoration-2">Imprint</Link>
            <Link to="/privacy" className="font-black uppercase text-sm hover:underline underline-offset-4 decoration-2">Privacy Policy</Link>
            <Link to="/terms" className="font-black uppercase text-sm hover:underline underline-offset-4 decoration-2">Terms of Service</Link>
          </div>

          {/* Social / Copyright */}
          <div className="flex flex-col items-center md:items-end justify-between h-full">
            <div className="hidden md:block text-xs font-black uppercase tracking-[0.2em] text-gray-400 mb-2">Social</div>
            <div className="font-black text-sm text-center md:text-right">
              © {new Date().getFullYear()} ETERA.STORE<br />
              <span className="text-gray-400">BUILT TO LAST.</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;